import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  Box,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const WarningDialog = ({ open, setOpen, setCheck, message, children }) => {
  return (
    <Dialog
      open={open}
      //onClose={() => setOpen(false)}
      PaperProps={{
        sx: {
          backgroundColor: "#1e1a1c",
          border: "1px solid rgba(255,255,255,0.07)",
          borderRadius: "12px",
          boxShadow: "0 24px 64px rgba(0,0,0,0.6)",
          minWidth: 380,
          overflow: "hidden",
        },
      }}
      slotProps={{
        backdrop: {
          sx: { backdropFilter: "blur(4px)", backgroundColor: "rgba(0,0,0,0.55)" },
        },
      }}
    >
      {/* Top accent bar */}
      <Box
        sx={{
          height: 3,
          background: "linear-gradient(90deg, #ce361e 0%, #e05a3a 100%)",
        }}
      />

      <DialogTitle
        sx={{
          backgroundColor: "transparent",
          px: 3,
          pt: 2.5,
          pb: 1.5,
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: "8px",
            backgroundColor: "rgba(206,54,30,0.12)",
            border: "1px solid rgba(206,54,30,0.25)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <WarningAmberIcon sx={{ fontSize: 18, color: "#ce361e" }} />
        </Box>
        <Typography
          sx={{
            fontSize: 18,
            fontWeight: 500,
            color: "#f0ece8",
            letterSpacing: "0.02em",
          }}
        >
          WARNING
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ backgroundColor: "transparent", px: 3, py: 1.5, mt: 2 }}>
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 400,
            color: "rgba(240,236,232,0.6)",
            lineHeight: 1.6,
          }}
        >
          {message}
          {children}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          backgroundColor: "transparent",
          px: 3,
          py: 1.5,
          gap: 1,
          justifyContent: "flex-end",
          borderTop: "1px solid rgba(255,255,255,0.06)",
        }}
      >
        <Button
          variant="outlined"
          size="small"
          onClick={() => setOpen(false)}
          sx={{
            color: "rgba(240,236,232,0.55)",
            borderColor: "rgba(255,255,255,0.1)",
            borderRadius: "7px",
            textTransform: "none",
            fontWeight: 500,
            fontSize: 12,
            px: 2,
            py: 0.5,
            minWidth: "unset",
            "&:hover": {
              borderColor: "rgba(255,255,255,0.2)",
              backgroundColor: "rgba(255,255,255,0.04)",
              color: "#f0ece8",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={() => setCheck(true)}
          sx={{
            backgroundColor: "#ce361e",
            borderRadius: "7px",
            textTransform: "none",
            fontWeight: 600,
            fontSize: 12,
            px: 2,
            py: 0.5,
            minWidth: "unset",
            boxShadow: "0 4px 14px rgba(206,54,30,0.35)",
            "&:hover": {
              backgroundColor: "#b82f19",
              boxShadow: "0 4px 18px rgba(206,54,30,0.5)",
            },
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WarningDialog;